import React, { useState } from 'react';
import { X, Lightbulb, Zap, Target } from 'lucide-react';

export default function WelcomeBanner({ userName, onDismiss }) {
  const [visible, setVisible] = useState(true);

  const handleDismiss = () => {
    setVisible(false);
    if (onDismiss) onDismiss();
  };

  if (!visible) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #66bb6a 0%, #42a5f5 100%)',
      borderRadius: '16px',
      padding: '32px',
      marginBottom: '32px',
      position: 'relative',
      boxShadow: '0 8px 24px rgba(102, 187, 106, 0.3)',
      color: 'white'
    }}>
      {/* Dismiss button */}
      <button
        onClick={handleDismiss}
        style={{
          position: 'absolute',
          top: '16px',
          right: '16px',
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'background 0.2s'
        }}
        onMouseOver={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
        onMouseOut={(e) => e.target.style.background = 'rgba(255,255,255,0.2)'}
      >
        <X size={18} color="white" />
      </button>

      {/* Content */}
      <div style={{ maxWidth: '900px' }}>
        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '12px' }}>
          🦦 Welcome back, {userName}!
        </h2>
        <p style={{ fontSize: '16px', opacity: 0.95, marginBottom: '24px', lineHeight: '1.6' }}>
          Ready to create amazing classroom materials? Here are some quick tips to get the most out of Teacher Material:
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
          {/* Tip 1 */}
          <div style={{
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '12px',
            padding: '16px',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <Lightbulb size={24} />
              <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Be Specific</h3>
            </div>
            <p style={{ fontSize: '14px', opacity: 0.9, margin: 0, lineHeight: '1.5' }}>
              The more details you provide about your lesson, the better your materials will be!
            </p>
          </div>

          {/* Tip 2 */}
          <div style={{
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '12px',
            padding: '16px',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <Zap size={24} />
              <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Save Favorites</h3>
            </div>
            <p style={{ fontSize: '14px', opacity: 0.9, margin: 0, lineHeight: '1.5' }}>
              Star your best materials in History so you can find them quickly later!
            </p>
          </div>

          {/* Tip 3 */}
          <div style={{
            background: 'rgba(255,255,255,0.15)',
            borderRadius: '12px',
            padding: '16px',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <Target size={24} />
              <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>Mix It Up</h3>
            </div>
            <p style={{ fontSize: '14px', opacity: 0.9, margin: 0, lineHeight: '1.5' }}>
              Each generation creates 5 different materials - worksheets, games, projects, and more!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}